// AuditLogUpdater の修正済みコード（このファイルが別ファイルなら差し替えてください）
import { useEffect, useState } from "react";
import supabase from "../../../utils/supabase"; // パスを調整
import { useSupabaseSession } from "../../../utils/AuthSessionProvider";

export default function AuditLogUpdater({
  tableName,
  rowId,
  action,
  beforeData = null,
  afterData = null,
  onComplete,
}) {
  const { user } = useSupabaseSession();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let didRun = false; // ⭐ 多重実行を防ぐ
    async function logAudit() {
      try {
        const actorId = user?.id || null;

        const { error: insertError } = await supabase.from("audit_log").insert([{
          table_name: tableName,
          row_id: rowId,
          action,
          actor_id: actorId,
          before_data: beforeData,
          after_data: afterData,
        }]);

        if (insertError) {
          setError(insertError.message);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
        if (!didRun && onComplete) {
          didRun = true;
          onComplete();
        }
      }
    }
    logAudit();
  }, [tableName, rowId, action, beforeData, afterData, onComplete]);

  if (loading) return null;
  if (error) return <div style={{ color: "red" }}>Audit log error: {error}</div>;
  return null;
}
